/**
 * Type guards for spot data model properties (spot_type_name, spot_type_prefix).
 * Shared by the data layer (useRoomLayoutMap) and legend UI (spotTypeLegend);
 * kept separate from legend so changes to the legend module do not affect data fetching.
 */

/** True when spot has spot_type_name as a non-empty string. */
export function hasSpotTypeName(spot: {
  spot_type_name?: unknown;
}): spot is { spot_type_name: string } {
  return typeof spot.spot_type_name === 'string' && spot.spot_type_name !== '';
}

/** True when spot has spot_type_prefix as a non-empty string. */
export function hasSpotTypePrefix(spot: {
  spot_type_prefix?: unknown;
}): spot is { spot_type_prefix: string } {
  return typeof spot.spot_type_prefix === 'string' && spot.spot_type_prefix !== '';
}
